export const isValidEmail = (email: string) => !!email.match(/^\S+@\S+\.\S+$/i);

export const isPasswordAcceptable = (pw: string) => pw.length > 7;

export const isValidUrl = (urlString: string) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export const getDashboardUrlById = (id: string) =>
  process.env.REACT_APP_PUBLIC_DASHBOARD_VIEWER_ROOT + id;

export const getDisplayUrl = (url: string) => url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
